import { Component, EventEmitter, Input, OnInit, Optional, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomFormControl, CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { BaseFormComponent } from '../base-form/base-form.component';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ModalOptionsConfig, ModalService } from '../nz-modal-service/modal.service';
import { SettingsService } from '@mpt-fo/common/core/services/settings.service';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { StorageKeys } from '../../../shared/models/storage-keys';
import { DialogMessageType } from '../../../shared/models/utility.model';

@Component({
  selector: 'app-set-business-pin',
  templateUrl: './set-business-pin.component.html',
  styleUrls: ['./set-business-pin.component.scss']
})
export class SetBusinessPinComponent extends BaseFormComponent implements OnInit {

  @Output() onBack = new EventEmitter();
  @Output() onSubmit = new EventEmitter();
  @Input() isMobile: boolean = false;
  @Input() isModal = false;
  @Input() submitted = false;
  showError = false;
  newPinControl: CustomFormControlDefinition;
  confirmPinControl: CustomFormControlDefinition;
  otpControl: CustomFormControlDefinition;
  isValidPin = true;
  currentView = 1;
  otpForm: FormGroup;
  otpTriggerResponse: { otpMessage, ussdCode } = {
    otpMessage: '',
    ussdCode: ''
  };
  triggeringOtp: boolean;
  otpError: string;
  validating: boolean;
  validationResponse: { message };
  hasUserPin = false;
  messageType: DialogMessageType;
  mobileModalTitle: string;
  mobileModalDesc: string;
  showSuccess: boolean;
  readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

  constructor(@Optional() public modalService: NzModalRef, private settingsService: SettingsService,
    private localStorageService: LocalStorageService,
    public modal: ModalService, private fb: FormBuilder) {
    super(fb);

    this.otpForm = new FormGroup({});

    this.newPinControl = new CustomFormControl()
      .id('pin')
      .placeholder('Pin')
      .name('pin')
      .type('password')
      .maxLength(4)
      .minLength(4)
      .isPin()
      .isRequired()
      .build();

    this.confirmPinControl = new CustomFormControl()
      .id('pin')
      .placeholder('Pin')
      .name('pin')
      .type('password')
      .maxLength(4)
      .minLength(4)
      .isPin()
      .isRequired()
      .build();

    this.otpControl = new CustomFormControl()
      .id('otp')
      .placeholder('Enter OTP')
      .name('otp')
      .isOTP()
      .type('password')
      .maxLength(6)
      .isRequired()
      .build();

    this.hasUserPin = JSON.parse(this.localStorageService.get(StorageKeys.HAS_USER_PIN));
  }

  ngOnInit(): void {
    if(this.modalService) this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
    this.isModal = this.modalService?.componentInstance?.data?.isModal ? true : false;
    this.form = this.fb.group({
      newPin: this.newPinControl.formGroupControl,
      confirmPin: this.confirmPinControl.formGroupControl,
    });

    this.otpForm = this.fb.group({
      otp: this.otpControl.formGroupControl
    });
  }

  setPin(event) {
    this.form.controls['newPin'].setValue(event);
  }

  setConfirmPin(event) {
    this.form.controls['confirmPin'].setValue(event);
    this.isValidPin = this.form.value.newPin == this.form.value.confirmPin
  }

  back() {
    !this.isModal ? this.onBack.emit() : this.modalService.destroy();
  }

  backStep(index) {
    this.currentView = index;
  }

  nextStep() {
    this.currentView++;
    if (this.currentView === 2) {
      this.triggerOtp();
    }
  }

  triggerOtp() {
    this.triggeringOtp = true;
    this.settingsService.triggerUserSetPinOtp().then(res => {
      this.otpTriggerResponse = res;
      this.triggeringOtp = false;
    }).catch(err => {
      this.otpError = StringHelper.getErrorMessageHttpErrorResponse(err);
      this.triggeringOtp = false;
    });
  }

  buildBody() {
    const form = this.otpForm.value;
    const body = {
      otp: form.otp,
      shouldPerformLivenessCheck: false
    };
    return body;
  }

  onSubmitEvent() {
    this.errorMessage = null;
    this.submitted = true;
    const body = {
      userPin: this.form.value.newPin,
      otp: this.otpForm.value.otp
    }
    this.settingsService.setUserPin(body).then(res => {
      this.submitted = false;
      this.hasUserPin = true;
      this.localStorageService.save(StorageKeys.HAS_USER_PIN, true);
      if (this.isMobile) {
        this.showSuccess = true;
        this.messageType = DialogMessageType.SUCCESS;
        this.mobileModalTitle = "Setup User Pin"
        this.mobileModalDesc = 'User pin has been set succesfully.';
      } else {
        this.modalService.componentInstance.callback(true);
        this.alertSuccess({
          title: 'Setup User Pin',
          description: 'User pin has been set succesfully',
        });
      }
    }).catch(err => {
      this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
      this.submitted = false;
    });
  }


  alertSuccess(data?) {
    const config = new ModalOptionsConfig();
    config.nzComponentParams.alertType = 'success';
    config.nzComponentParams.title = data?.title;
    config.nzComponentParams.message = data?.description;
    config.nzComponentParams.callback = () => {
      this.modalService.destroy();
      // this.onBack.emit();
    }
    this.modal.alert(config);
  }

  closeSuccessModal() {
    this.showSuccess = false;
    this.onBack.emit();
  }


}
